import { render, staticRenderFns } from "./Topes.vue?vue&type=template&id=39a34771&scoped=true"
import script from "./Topes.vue?vue&type=script&lang=js"
export * from "./Topes.vue?vue&type=script&lang=js"
import style0 from "./Topes.vue?vue&type=style&index=0&id=39a34771&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a34771",
  null
  
)

export default component.exports